<div class="ai-loading">
  <div class="ai-loading__emblem" aria-hidden="true">
    <span class="halo halo--1"></span>
    <span class="halo halo--2"></span>
    <div class="core">
      <mat-icon>auto_awesome</mat-icon>
    </div>
  </div>

  <h2 class="ai-loading__title">
    Building your AI search<span class="dots" aria-hidden="true"
      ><i>.</i><i>.</i><i>.</i></span
    >
  </h2>
  <p class="ai-loading__subject" *ngIf="subject">
    {{ subject }}
  </p>

  <div class="ai-loading__stages" *ngIf="loadingStages.length > 0">
    <ng-container *ngFor="let stage of loadingStages; let first = first">
      <span
        *ngIf="!first"
        class="stage-link"
        [class.stage-link--done]="loadingStages[0].state === 'done'"
      ></span>
      <div class="stage stage--{{ stage.state }}">
        <span class="stage__marker">
          <mat-icon *ngIf="stage.state === 'done'">check</mat-icon>
          <span *ngIf="stage.state === 'active'" class="stage__ring"></span>
          <span *ngIf="stage.state === 'pending'" class="stage__dot"></span>
        </span>
        <span class="stage__label">{{ stage.label }}</span>
      </div>
    </ng-container>
  </div>

  <!-- Re-created on every hint change so the entry animation replays -->
  <p class="ai-loading__hint" *ngFor="let hint of [currentHint]">
    {{ hint }}
  </p>

  <div class="ai-loading__bar" aria-hidden="true"><span></span></div>

  <div class="ai-loading__footer">
    <span class="eta">Usually takes under a minute</span>
    <button mat-button type="button" (click)="cancelLoading.emit()">
      Cancel
    </button>
  </div>
</div>
